import { useContext, useEffect, useState } from "react"
import Description from "./Description"
import Detail from "./Detail"
import Gallery from "./Gallery"
import RelatedProduct from "./RelatedProduct"
import { CustomVariantItemProps, MinProductItemProps, ProductDetailItemProps, ProductVariantItemProps } from "./constants"
import { NextSeo, ProductJsonLd } from "next-seo"
import { useAttributesStore } from "@/stores/useAttributesStore"
import { AttributeValueItem } from "@/lib/constants"
import { Offers, Review } from "next-seo/lib/types"
import Rating from "./Rating"
import TabDetail from "./TabDetail"
import AddToCart from "./AddToCart"
import { useRecommendStore } from "@/stores/useRecommendStore"
import { useRouter } from "next/router"
import PwP from "./PwP"
import { GlobalContext, GlobalState } from "@/context/useGlobalContext"
import Cookies from "js-cookie"
import axios from "axios"
import { useUserStore } from "@/stores/useUserStore"
import { v4 as uuidv4 } from 'uuid'
import { event } from 'nextjs-google-analytics'


const Product = (props: ProductDetailItemProps) => {
  const router = useRouter();
  const { showCart, setShowCart } = useContext(GlobalContext) as GlobalState;
  const { getAttributes } = useAttributesStore();
  const { updateRecommend } = useRecommendStore();
  const { userInfo, updateUser, getUser } = useUserStore();
  const [userData, setUserData] = useState(getUser());
  const [variantId, setVariantId] = useState(0);
  const [selectProduct, setSelectProduct] = useState<MinProductItemProps | null>(null);
  const [variant, setVariant] = useState<ProductVariantItemProps | null>(null);
  const [relatedVariant, setRelatedVariant] = useState<ProductVariantItemProps | null>(null);
  const [open, setOpen] = useState(false);
  const [relatedOpen, setRelatedOpen] = useState(false);
  const attributesData = getAttributes();
  const [refresh, setRefresh] = useState(false);
  const [firstVariant, setFirstVariant] = useState<ProductVariantItemProps | null>(null);
  const [init, setInit] = useState(true);
  const [colors, setColors] = useState<Array<AttributeValueItem>>([])
  const [sizes, setSizes] = useState<Array<AttributeValueItem>>([])
  const [stages, setStages] = useState<Array<AttributeValueItem>>([])
  const [patterns, setPatterns] = useState<Array<AttributeValueItem>>([])
  const [genders, setGenders] = useState<Array<AttributeValueItem>>([])
  const [flavours, setFlavours] = useState<Array<AttributeValueItem>>([])
  const [selectColor, setSelectColor] = useState<number>(0)
  const [selectSize, setSelectSize] = useState<number>(0)
  const [selectStage, setSelectStage] = useState<number>(0)
  const [selectPattern, setSelectPattern] = useState<number>(0)
  const [selectGender, setSelectGender] = useState<number>(0)
  const [selectFlavour, setSelectFlavour] = useState<number>(0)
  const [additionalImages, setAdditionalImages] = useState<Array<string>>([])
  const [offerVariants, setOfferVariants] = useState<Array<Offers>>([])
  const [reviewList, setReviewList] = useState<Array<Review>>([])
  const [selectedCustomVariant, setSelectedCustomVariant] = useState<CustomVariantItemProps | null>(null)
  const [fromName, setFromName] = useState<string>('')
  const [toName, setToName] = useState<string>('')
  const [toEmail, setToEmail] = useState<string>('')
  const [toMobile, setToMobile] = useState<string>('')
  const [toMessage, setToMessage] = useState<string>('')
  const [pregnancy, setPregnancy] = useState<string>('')
  const [duDate, setDuDate] = useState<Date | null>(null)
  const [childName, setChildName] = useState<string>('')
  const [childAge, setChildAge] = useState<number | null>(null)
  const [childGender, setChildGender] = useState<string>('')
  const [sharedSalesPrice, setSharedSalesPrice] = useState<number>(0)
  const [affiliate, setAffiliate] = useState<string | undefined>(undefined);
  const [clickAttribute, setClickAttribute] = useState<boolean>(false);

  useEffect(() => {
    if (selectProduct !== null && !relatedOpen) {
      setRelatedOpen(true);
    }
  }, [selectProduct, relatedOpen])

  useEffect(() => {
    if (!relatedOpen) {
      setSelectProduct(null);
      setRelatedVariant(null);
    }
  }, [relatedOpen])

  useEffect(() => {
    const parser_attributes = async () => {
      setAdditionalImages([]);
      setOfferVariants([]);
      setReviewList([]);

      const priceValidDate = new Date(new Date().getTime() + 5 * 24 * 60 * 60 * 1000);
      const priceValidUntil = `${priceValidDate.getFullYear()}-${(priceValidDate.getMonth() + 1).toString().padStart(2, '0')}-${priceValidDate.getDate().toString().padStart(2, '0')}`

      try {
        for (var i = 0; i < attributesData.data.length; i++) {
          const filtered = attributesData.data[i].attribute_values.filter((attribute) => props.attribute_value_list.some((value) => attribute.id === value)).sort((a, b) => (a.order === b.order) ? a.id - b.id : a.order - b.order);

          switch (attributesData.data[i].slug) {
            case "color":
              setColors(filtered);

              if (filtered.length > 0) {
                setSelectColor(filtered[0].id);
              }
              break;

            case "size":
              setSizes(filtered);

              if (filtered.length > 0) {
                setSelectSize(filtered[0].id);
              }
              break;

            case "stage":
              setStages(filtered);

              if (filtered.length > 0) {
                setSelectStage(filtered[0].id);
              }
              break;

            case "pattern":
              setPatterns(filtered);

              if (filtered.length > 0) {
                setSelectPattern(filtered[0].id);
              }
              break;

            case "gender":
              setGenders(filtered);

              if (filtered.length > 0) {
                setSelectGender(filtered[0].id);
              }
              break;

            case "flavour":
              setFlavours(filtered);

              if (filtered.length > 0) {
                setSelectFlavour(filtered[0].id);
              }
              break;
          }
        }
      } finally {
        props.image_gallery.slice(1).map((image) => {
          if (image && image.image && image.image !== undefined) {
            setAdditionalImages(prevImages => [...prevImages, image.image]);
          }
        });

        props.product_variant_list.map((v) => {
          const color = colors.find((c) => v.attribute_value_list.includes(c.id));
          const size = sizes.find((s) => v.attribute_value_list.includes(s.id));
          const stage = stages.find((s) => v.attribute_value_list.includes(s.id));
          const pattern = patterns.find((p) => v.attribute_value_list.includes(p.id));
          const gender = genders.find((g) => v.attribute_value_list.includes(g.id));
          const flavour = flavours.find((f) => v.attribute_value_list.includes(f.id));

          const ov = {
            price: (v.special_price > 0 ? v.special_price : v.sales_price).toString(),
            priceValidUntil: priceValidUntil,
            priceCurrency: process.env.NEXT_PUBLIC_CURRENCY_CODE || 'VND', // Provide a default value to ensure it is always a string
            url: process.env.NEXT_PUBLIC_HOSTNAME + "/product/" + props.slug,
            availability: v.qty > 0 ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
            itemCondition: "https://schema.org/NewCondition",
            seller: {
              name: "MOOIMOM"
            },
            ...({ name: props.name }),
            ...({ sku: v.product_code }),
            ...(color !== undefined && { color: color.base_color !== null && color.base_color.length > 0 ? color.base_color : color.name }),
            ...(size !== undefined && { size: size.name }),
            ...(stage !== undefined && { stage: stage.name }),
            ...(pattern !== undefined && { pattern: pattern.name }),
            ...(gender !== undefined && { gender: gender.name }),
            ...(flavour !== undefined && { flavour: flavour.name }),
          }

          setOfferVariants(prevVariants => [...prevVariants, ov]);
        })

        if (props.rating && props.rating.review_list && props.rating.review_list.length > 0) {
          props.rating.review_list.map((review) => {
            setReviewList(prevReviews => [...prevReviews, {
              author: review.customer_name,
              datePublished: review.review_date,
              reviewBody: review.content,
              name: review.title,
              reviewRating: {
                bestRating: props.rating.best_rating.toString(),
                ratingValue: review.star_value.toString(),
                worstRating: props.rating.worst_rating.toString(),
              }
            }])
          })
        }

        event("view_item", {
          category: "ecommerce",
          currency: process.env.NEXT_PUBLIC_CURRENCY_CODE || 'VND',
          value: props.sales_price * props.qty,
          items: [
            {
              item_id: props.product_code,
              item_name: props.name,
              brand: props.brand,
            }
          ]
        });

        try {
          window.fbq('track', 'viewContent', {
            content_ids: [props.product_code],
            content_name: props.name,
            content_type: 'product',
            value: props.sales_price * props.qty,
            currency: process.env.NEXT_PUBLIC_CURRENCY_CODE || 'VND',
          })
        } catch (error) { }
      }
    }

    if (init) {
      parser_attributes();

      setInit(false);
    }
  }, [props.attribute_value_list, attributesData, variant, init, props.image_gallery, additionalImages, props.product_variant_list, props.slug, props.name, colors, sizes, stages, patterns, genders, flavours]);

  useEffect(() => {
    const attr = [selectColor, selectSize, selectStage, selectPattern, selectGender, selectFlavour].filter((value) => value !== 0).sort((a, b) => a - b)
    const variants = props.product_variant_list.filter((variant) => variant.attribute_value_list.sort((a, b) => a - b).toString() == attr.toString())

    setFirstVariant(variants[0]);
  }, [selectColor, selectSize, selectStage, selectPattern, selectGender, selectFlavour, props.product_variant_list, setFirstVariant])

  useEffect(() => {
    const process_refresh = () => {
      setRefresh(false);

      if (props.our_pick.length > 0 && props.our_pick[0].product_list.length > 0) {
        const recommend = {
          update_date: Date.now(),
          data: props.our_pick[0].product_list
        }

        updateRecommend(recommend);
      }
    }

    if (refresh && props.slug !== null) {
      process_refresh();
    }
  }, [refresh, props.slug, props.our_pick, updateRecommend])

  useEffect(() => {
    const handleAffiliate = async () => {
      let category = '';

      if (router.query.utm_source === "affiliate" && router.query.utm_medium !== undefined && router.query.utm_medium !== null) {
        Cookies.set(window.btoa("affiliate"), router.query.utm_medium.toString(), { expires: 1, path: '/' });
        setAffiliate(router.query.utm_medium.toString());
        category = window.btoa("affiliate," + router.query.utm_medium.toString());
      } else {
        category = window.btoa("affiliate," + Cookies.get(window.btoa("affiliate")) || "");
      }

      try {
        let uuid = userData.uuid;

        if (uuid === undefined || uuid === null) {
          uuid = uuidv4();
          userData.uuid = uuid;
          setUserData(userData);
          updateUser(userData);
        }

        const response = await axios.get(
          "/api/product",
          {
            headers: { 'Authorization': 'Bearer ' + userData.token },
            params : {
              category: category,
              utm_source: router.query.utm_source,
              utm_medium: router.query.utm_medium,
              utm_campaign: router.query.utm_campaign,
              utm_content: router.query.utm_content,
              uid: uuid,
              slug: router.query.slug,
            }
          }
        );

        if (response.data.status === "ok" && response.data.data !== null) {
          const data = JSON.parse(window.atob(response.data.data));

          if (data.shared_sales_price !== undefined && data.shared_sales_price !== null) {
            setSharedSalesPrice(data.shared_sales_price);
          }
        }
      } catch (error) {
        console.log(error)
      }
    }

    const affiliate = Cookies.get(window.btoa("affiliate"));

    setAffiliate(affiliate);

    if ((router.query.utm_source !== undefined && router.query.utm_source !== null && router.query.utm_source === "affiliate" && router.query.utm_medium !== undefined && router.query.utm_medium !== null) || (affiliate !== null && affiliate !== undefined)) {
      handleAffiliate();
    }
  }, [router.query.slug, router.query.utm_campaign, router.query.utm_content, router.query.utm_medium, router.query.utm_source, updateUser, userData, userData.token, userData.uuid])

  useEffect(() => {
    if (router.query.utm_source === "pdf" && router.query.utm_medium === "document") {
      Cookies.set(
        window.btoa(router.query.utm_source.toString()),
        window.btoa(router.query.utm_medium.toString()),
        { expires: 3650, path: '/' }
      );
    }
  }, [router.query.utm_source, router.query.utm_medium]);

  const handleRouteChange = () => {
    setInit(true);
    setRefresh(true);
    setVariant(null);
    setVariantId(0);
    setAdditionalImages([]);
    setOfferVariants([]);
    setSharedSalesPrice(0);
    setClickAttribute(false);
  }

  useEffect(() => {
    router.events.on('routeChangeComplete', handleRouteChange)
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    };
  }, [router.events]);

  return (
    <>
      <NextSeo
        title=''
        defaultTitle={props.meta.title}
        description={props.meta.description}
        canonical={process.env.NEXT_PUBLIC_HOSTNAME + "/product/" + props.slug}
        openGraph={{
          images: [{
            url: props.image_gallery.length > 0 ? props.image_gallery[0].image : process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/logo-mooimom-middle.png",
            width: 800,
            height: 800,
            alt: props.name + " image",
          }]
        }}
      />
      <ProductJsonLd
        productName={props.name}
        images={props.image_gallery.length > 0 ? [props.image_gallery[0].image] : [process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/logo-mooimom-middle.png"]}
        description={props.meta.description}
        brand={props.brand}
        sku={props.product_code}
        offers={offerVariants.length > 0 ? offerVariants : offerVariants[0]}
        additional_images={additionalImages.length > 0 ? additionalImages : undefined}
        aggregateRating={
          props.rating.counts > 0 ? {
            ratingValue: props.rating.review_rating,
            reviewCount: props.rating.counts,
          } : {
            ratingValue: 3.0,
            reviewCount: 1,
          }
        }
        reviews={reviewList}
      />
      <div className="grid grid-cols-1 gap-0 mb-8 md:container md:my-0 md:py-12 md:grid-cols-12 md:gap-6">
        <Gallery
          product_code={props.product_code}
          name={props.name}
          product_variant_list={props.product_variant_list}
          image_gallery={props.image_gallery}
          product_label_right_top={props.product_label_right_top}
          product_label_right_product_page={props.product_label_right_product_page}
          product_label_left_product_page={props.product_label_left_product_page}
          variantId={variantId}
          use_product_option={props.use_product_option}
          selectColor={selectColor}
          clickAttribute={clickAttribute}
        />
        <Detail
          id={props.id}
          name={props.name}
          msrp={props.msrp}
          sales_price={props.sales_price}
          product_code={props.product_code}
          qty={props.qty}
          ranking={props.ranking}
          attribute_value_list={props.attribute_value_list}
          categories_list={props.categories_list}
          product_variant_list={props.product_variant_list}
          image_gallery={props.image_gallery}
          description_list={props.description_list}
          description_media_list={props.description_media_list}
          people_say={props.people_say}
          our_pick={props.our_pick}
          meta={props.meta}
          size_guide={props.size_guide}
          product_label_right_top={props.product_label_right_top}
          product_label_right_product_page={props.product_label_right_product_page}
          product_label_left_product_page={props.product_label_left_product_page}
          urls={props.urls}
          special_price={props.special_price}
          brand={props.brand}
          slug={props.slug}
          setVariantId={setVariantId}
          rating={props.rating}
          promotion={props.promotion}
          selling_points={props.selling_points}
          how_to_use={props.how_to_use}
          pwp_name={props.pwp_name}
          pwp={props.pwp}
          setOpen={setOpen}
          variant={variant}
          setVariant={setVariant}
          firstVariant={firstVariant}
          virtual_product={props.virtual_product}
          need_shipping={props.need_shipping}
          custom_variant_list={props.custom_variant_list}
          video_list={props.video_list}
          use_product_option={props.use_product_option}
          selectedCustomVariant={selectedCustomVariant}
          setSelectedCustomVariant={setSelectedCustomVariant}
          fromName={fromName}
          setFromName={setFromName}
          toName={toName}
          setToName={setToName}
          toEmail={toEmail}
          setToEmail={setToEmail}
          toMobile={toMobile}
          setToMobile={setToMobile}
          toMessage={toMessage}
          setToMessage={setToMessage}
          pregnancy={pregnancy}
          setPregnancy={setPregnancy}
          duDate={duDate}
          setDuDate={setDuDate}
          childName={childName}
          setChildName={setChildName}
          childAge={childAge}
          setChildAge={setChildAge}
          childGender={childGender}
          setChildGender={setChildGender}
          sharedSalesPrice={sharedSalesPrice}
          affiliate={affiliate}
          setClickAttribute={setClickAttribute}
          setSelectColor={setSelectColor}
        />
      </div>
      {props.pwp.length > 0 && (
        <>
          <hr className="my-6 bg-reviewBg md:hidden" />
          <div className="container">
            <hr className="hidden mb-6 bg-reviewBg md:block" />
            <PwP pwp={props.pwp} pwp_name={props.pwp_name} setSelectProduct={setSelectProduct} />
          </div>
          <hr className="my-6 bg-reviewBg md:hidden" />
        </>
      )}
      {props.rating.counts > 0 && (
        <div className="mb-12 md:container md:mb-20">
          <Rating rating={props.rating} slug={props.slug} />
        </div>
      )}
      <div className="mb-12 md:container md:mb-20">
        <Description
          name={props.name}
          description_media_list={props.description_media_list}
        />
      </div>
      <div className="container hidden grid-cols-5 mb-20 md:grid">
        <div className={`col-span-3 pr-20 ${process.env.NEXT_PUBLIC_STYLE_OPTION === "A" ? "hidden" : ""}`}>
          <TabDetail details={props.description_list} how_to_use={props.how_to_use} />
        </div>
        <div className={process.env.NEXT_PUBLIC_STYLE_OPTION === "A" ? "col-span-5" : "col-span-2"}>
          <RelatedProduct
            our_pick={props.our_pick}
            setSelectProduct={setSelectProduct}
            selectedCustomVariant={selectedCustomVariant}
            setSelectedCustomVariant={setSelectedCustomVariant}
            fromName={fromName}
            setFromName={setFromName}
            toName={toName}
            setToName={setToName}
            toEmail={toEmail}
            setToEmail={setToEmail}
            toMobile={toMobile}
            setToMobile={setToMobile}
            toMessage={toMessage}
            setToMessage={setToMessage}
            pregnancy={pregnancy}
            setPregnancy={setPregnancy}
            duDate={duDate}
            setDuDate={setDuDate}
            childName={childName}
            setChildName={setChildName}
            childAge={childAge}
            setChildAge={setChildAge}
            childGender={childGender}
            setChildGender={setChildGender}
          />
        </div>
      </div>
      <div className="mb-12 md:hidden">
        <RelatedProduct
          our_pick={props.our_pick}
          setSelectProduct={setSelectProduct}
          selectedCustomVariant={selectedCustomVariant}
          setSelectedCustomVariant={setSelectedCustomVariant}
          fromName={fromName}
          setFromName={setFromName}
          toName={toName}
          setToName={setToName}
          toEmail={toEmail}
          setToEmail={setToEmail}
          toMobile={toMobile}
          setToMobile={setToMobile}
          toMessage={toMessage}
          setToMessage={setToMessage}
          pregnancy={pregnancy}
          setPregnancy={setPregnancy}
          duDate={duDate}
          setDuDate={setDuDate}
          childName={childName}
          setChildName={setChildName}
          childAge={childAge}
          setChildAge={setChildAge}
          childGender={childGender}
          setChildGender={setChildGender}
        />
      </div>
      {variant !== null && (
        <AddToCart
          id={props.id}
          name={props.name}
          msrp={props.msrp}
          sales_price={props.sales_price}
          product_code={props.product_code}
          qty={props.qty}
          image={props.image_gallery[0].image}
          attribute_value_list={props.attribute_value_list}
          product_variant_list={props.product_variant_list}
          special_price={props.special_price}
          brand={props.brand}
          slug={props.slug}
          style="popup"
          variant={variant}
          setVariant={setVariant}
          setShowCart={setShowCart}
          action="add"
          open={open}
          setOpen={setOpen}
          virtual_product={props.virtual_product}
          need_shipping={props.need_shipping}
          custom_variant_list={props.custom_variant_list}
          selectedCustomVariant={selectedCustomVariant}
          setSelectedCustomVariant={setSelectedCustomVariant}
          fromName={fromName}
          setFromName={setFromName}
          toName={toName}
          setToName={setToName}
          toEmail={toEmail}
          setToEmail={setToEmail}
          toMobile={toMobile}
          setToMobile={setToMobile}
          toMessage={toMessage}
          setToMessage={setToMessage}
          pregnancy={pregnancy}
          setPregnancy={setPregnancy}
          duDate={duDate}
          setDuDate={setDuDate}
          childName={childName}
          setChildName={setChildName}
          childAge={childAge}
          setChildAge={setChildAge}
          childGender={childGender}
          setChildGender={setChildGender}
          pwp_name={props.pwp_name}
          pwp={props.pwp}
          shared_sales_price={sharedSalesPrice}
          type={affiliate !== null && affiliate !== undefined ? "affiliate" : "ec"}
          use_product_option={props.use_product_option}
        />
      )}
      {selectProduct !== null && (
        <AddToCart
          id={selectProduct.id}
          name={selectProduct.name}
          msrp={selectProduct.msrp}
          sales_price={selectProduct.sales_price}
          product_code={selectProduct.sku}
          qty={selectProduct.qty}
          image={selectProduct.image}
          attribute_value_list={selectProduct.attribute_value_list}
          product_variant_list={selectProduct.product_variant_list}
          special_price={selectProduct.special_price}
          brand={selectProduct.brand}
          slug={selectProduct.slug}
          style="popup"
          variant={relatedVariant}
          setVariant={setRelatedVariant}
          setShowCart={setShowCart}
          action="add"
          open={relatedOpen}
          setOpen={setRelatedOpen}
          virtual_product={selectProduct.virtual_product}
          need_shipping={selectProduct.need_shipping}
          custom_variant_list={selectProduct.custom_variant_list}
          selectedCustomVariant={selectedCustomVariant}
          setSelectedCustomVariant={setSelectedCustomVariant}
          fromName={fromName}
          setFromName={setFromName}
          toName={toName}
          setToName={setToName}
          toEmail={toEmail}
          setToEmail={setToEmail}
          toMobile={toMobile}
          setToMobile={setToMobile}
          toMessage={toMessage}
          setToMessage={setToMessage}
          pregnancy={pregnancy}
          setPregnancy={setPregnancy}
          duDate={duDate}
          setDuDate={setDuDate}
          childName={childName}
          setChildName={setChildName}
          childAge={childAge}
          setChildAge={setChildAge}
          childGender={childGender}
          setChildGender={setChildGender}
          pwp_name={selectProduct.pwp_name}
          pwp={selectProduct.pwp}
          shared_sales_price={null}
          type={affiliate !== null && affiliate !== undefined ? "affiliate" : "ec"}
        />
      )}
    </>
  )
}

export default Product
